import TableButton from 'components/common/Buttons/TableButton'
import Table from 'components/common/Table'
import React, { useEffect, useState } from 'react'
import Calls from '../Calls'

const Accounts = ({ client: { title, endpoint, id: clientId } }) => {
  const [selectedAccount, setSelectedAccount] = useState(null)
  const aditionalColumns = [
    {
      Header: 'Llamadas',
      Cell: ({
        row: {
          original: {
            id, calls, firstName, lastName,
          },
        },
        cellCustomData,
      }) => {
        return (
          <TableButton
            selected={id === cellCustomData?.id}
            clickHandler={() =>
              setSelectedAccount((ps) =>
                ps?.id === id
                  ? null
                  : {
                    endpoint: calls,
                    title: `${firstName} ${lastName}`,
                    id,
                  })}
          >
            Ver Llamadas
          </TableButton>
        )
      },
    },
  ]

  useEffect(() => {
    setSelectedAccount(null)
  }, [endpoint])

  return (
    <Table
      key={clientId}
      endpoint={endpoint}
      title={`Cuentas de ${title}`}
      aditionalColumns={aditionalColumns}
      searchOptions={SEARCH_OPTIONS}
      orderOptions={ORDER_OPTIONS}
      cellCustomData={selectedAccount}
    >
      {selectedAccount && (
        <Calls
          title={`Llamadas de ${selectedAccount.title}`}
          endpoint={selectedAccount.endpoint}
          columnsToSkip={CALLS_COLUMNS_TO_SKIP}
        />
      )}
    </Table>
  )
}

const SEARCH_OPTIONS = ['email', 'firstName', 'lastName']
const ORDER_OPTIONS = ['email', 'firstName', 'lastName']

const CALLS_COLUMNS_TO_SKIP = ['accountFullName', 'accountEmail']

export default Accounts
